import { useViewport } from 'components/general/useViewPort';
import React, { useMemo }  from 'react';
import MirsTable from "components/general/table/Table";
import { getPhase } from 'helpers/rsc'
import { isSemiFinal } from "components/sports/sal/helper/SalHelpers"
import { SummaryColumnsFinal, SummaryColumnsSemiFinal } from "components/sports/sal/components/Columns"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Label from 'components/general/Label';

const getConfiguration = (dataUnits) => {
    return {
        columnsSFNL1: SummaryColumnsSemiFinal(dataUnits, 'SFNL0001'),
        columnsSFNL2: SummaryColumnsSemiFinal(dataUnits, 'SFNL0001'),
        columnsFNL: SummaryColumnsFinal(dataUnits),
    }
};

const SalFinalSummary = ({ data, dataUnits }) => {
    const { breakPoint } = useViewport();
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const _phase = getPhase(mirs_rsc)    
    const isSFNL = isSemiFinal(_phase)

    const configEvent = useMemo(() => getConfiguration( dataUnits, breakPoint), [breakPoint]);
    
    let tableData1 = isSFNL
        ? data?.cumulativeResults?.results?.filter(r => r.extendedResults.find(er =>er.er_code === 'SFNL' && er.er_pos === "A"))
        : data?.cumulativeResults?.results?.filter(r => r.extendedResults.find(er =>er.er_code === 'FNL'))
    
    let tableData2 = isSFNL
        ? data?.cumulativeResults?.results?.filter(r => r.extendedResults.find(er =>er.er_code === 'SFNL'  && er.er_pos === "B"))
        : null


    return (
        <>
        {isSFNL
        ?
        <>
            <MirsTable
                data={tableData1}
                columns={configEvent.columnsSFNL1}
                caption={<><Label data='HeaderSFL' /> A</>}
                initialSortBy={[{ id: 'Rank', desc: false }]}
                id={`mirs-table-summary-1-${mirs_rsc}`}
            />
            <MirsTable
                data={tableData2}
                columns={configEvent.columnsSFNL2}
                caption={<><Label data='HeaderSFL' /> B</>}
                initialSortBy={[{ id: 'Rank', desc: false }]}
                id={`mirs-table-summary-2-${mirs_rsc}`}
                />
        </>
        :
            <MirsTable
                data={tableData1}
                columns={configEvent.columnsFNL}
                caption={<Label data='HeaderFinalSummary'/>}
                initialSortBy={[{ id: 'Rank', desc: false }]}
                id={`mirs-table-summary-${mirs_rsc}`}
            />

       }
        </>
    )

}

export default SalFinalSummary;